const age = [...Array(100).keys()]

const ageStr = age.map((item) => item.toString())

export default ageStr
